/* global zE $zopim */

/**
 * This file will be loaded in the <head> tag
 *
 * NOTE: The code here will NOT be transpilled or have polyfills.
 * Ensure code is IE friendly
 */

import {
  isChatSupported,
  getWidgetSettings,
  getLocalisedChatLabel,
  getKey,
  defaultDepartments,
} from './config/override-config';
import Cookies from 'js-cookie';
import { parse } from 'querystring';

const baseClassName = 'ZendeskAesopChat';
const iframeContainerClass = `${baseClassName}-parentContainer`;
const launcherClassName = `${baseClassName}-launcher`;
const indicatorClassName = `${baseClassName}-indicator`;
const newMessageClassName = `${baseClassName}-newMessage`;
const notificationsCookieName = 'zendeskNotifications';

function isZeDefined() {
  return typeof window.zE !== 'undefined';
}

function getChatDepartmentDetails() {
  const market = window.location.pathname.split(/(\/\/?)/);
  let departmentList = [];
  let departmentSelect = defaultDepartments.englishTeam;
  let tag = 'AU_Team';
  let language = '';
  let talkSuppress = true;
  let talkNickname = '';

  switch (market[2]) {
    case 'au':
      departmentList = [defaultDepartments.englishTeam];
      departmentSelect = defaultDepartments.englishTeam;
      tag = 'AU_Team';
      language = 'en-au';
      talkSuppress = false;
      talkNickname = 'Australia';
      break;
    case 'nz':
      departmentList = [defaultDepartments.englishTeam];
      departmentSelect = defaultDepartments.englishTeam;
      tag = 'New Zealand';
      language = 'en-nz';
      break;
    case 'jp':
      departmentList = [360001127715, 360001127695, 360001115016];
      departmentSelect = defaultDepartments.jp;
      tag = 'JP_Team';
      language = 'ja';
      talkSuppress = false;
      talkNickname = 'Japan';
      break;
    case 'kr':
      departmentList = [defaultDepartments.kr];
      departmentSelect = defaultDepartments.kr;
      tag = 'KR_Team';
      language = 'ko';
      talkSuppress = true;
      talkNickname = 'Korea';
      break;
    case 'ca':
      if (market[4] === 'en') {
        language = 'en-ca';
      } else {
        language = 'fr-ca';
      }
      departmentList = [defaultDepartments.englishTeam];
      departmentSelect = defaultDepartments.englishTeam;
      tag = 'USA_Canada';
      break;
    case 'us':
      departmentList = [defaultDepartments.englishTeam];
      departmentSelect = defaultDepartments.englishTeam;
      tag = 'USA_Canada';
      language = 'en-us';
      talkSuppress = false;
      talkNickname = 'Us';
      break;
    case 'sg':
      departmentList = defaultDepartments.asiaTeam;
      departmentSelect = defaultDepartments.asiaTeam;
      tag = 'Singapore';
      language = 'en-sg';
      talkSuppress = false;
      talkNickname = 'Singapore';
      break;
    case 'hk':
      if (market[4] === 'en') {
        language = 'en-hk';
      } else if (market[4] === 'zh_cn') {
        language = 'zh-cn';
      } else {
        language = 'zh-hk';
      }
      departmentList = [defaultDepartments.asiaTeam];
      departmentSelect = defaultDepartments.asiaTeam;
      talkSuppress = false;
      talkNickname = 'Hong Kong';
      tag = 'HK_Team';
      break;
    case 'ch':
      if (market[4] === 'en') {
        departmentList = [defaultDepartments.franceTeam];
        departmentSelect = defaultDepartments.franceTeam;
        language = 'en-ch';
      } else if (market[4] === 'fr') {
        departmentList = [defaultDepartments.dachTeam];
        departmentSelect = defaultDepartments.dachTeam;
        language = 'fr-ch';
      } else {
        departmentList = [defaultDepartments.dachTeam];
        departmentSelect = defaultDepartments.dachTeam;
        language = 'de-ch';
      }
      talkSuppress = false;
      talkNickname = 'Switzerland';
      tag = 'CH_TEAM';
      break;
    case 'tw':
      departmentList = [defaultDepartments.asiaTeam];
      departmentSelect = defaultDepartments.asiaTeam;
      language = 'zh-tw';
      talkSuppress = false;
      talkNickname = 'Taiwan';
      tag = 'TW_TEAM';
      break;
    case 'uk':
      departmentList = [defaultDepartments.englishTeam];
      departmentSelect = defaultDepartments.englishTeam;
      tag = 'UK_Team';
      language = 'en-gb';
      talkSuppress = false;
      talkNickname = 'Uk';
      break;
    case 'fr':
      if (market[4] === 'en') {
        language = 'en-150';
      } else {
        language = 'fr-fr';
      }
      tag = 'FR_Team';
      departmentList = [defaultDepartments.franceTeam];
      departmentSelect = defaultDepartments.franceTeam;
      break;
    case 'de':
      if (market[4] === 'en') {
        language = 'en-150';
      } else {
        language = 'de';
      }
      tag = 'DE_Team';
      departmentList = [defaultDepartments.dachTeam];
      departmentSelect = defaultDepartments.dachTeam;
      break;
    default:
      departmentList = [defaultDepartments.englishTeam];
      departmentSelect = defaultDepartments.englishTeam;
      tag = 'AU_Team';
      language = 'en-au';
      break;
  }

  return {
    market,
    departmentList,
    departmentSelect,
    tag,
    language,
    talkSuppress,
    talkNickname,
  };
}

function initMessenger(zE) {
  const zendeskContainer = document.createElement('div');
  zendeskContainer.classList.add(iframeContainerClass);

  const launcher = document.createElement('button');
  launcher.innerHTML = getLocalisedChatLabel();
  launcher.classList.add(launcherClassName);
  launcher.classList.add('isMessenger');
  launcher.setAttribute('type', 'button');

  launcher.addEventListener('click', function () {
    zE('messenger', 'open');
    zE('messenger', 'show');
  });

  // create unread message count holder
  if (document.getElementsByClassName(indicatorClassName).length < 1) {
    const unreadMessagesCount = Cookies.get(notificationsCookieName);
    const messageIndicator = document.createElement('div');

    if (unreadMessagesCount) {
      messageIndicator.innerHTML = unreadMessagesCount;
      messageIndicator.style.display = 'block';
      launcher.classList.add('has-newMessage');
    } else {
      messageIndicator.style.display = 'none';
    }

    messageIndicator.classList.add(indicatorClassName);
    launcher.append(messageIndicator);
  }

  zE('messenger:on', 'close', function () {
    const messageIndicator = document.getElementsByClassName(
      indicatorClassName
    )[0];
    messageIndicator.style.display = 'none';
    launcher.style.visibility = 'visible';
    launcher.classList.remove('has-newMessage');
  });

  zE('messenger:on', 'open', function () {
    launcher.style.visibility = 'hidden';
    Cookies.remove(notificationsCookieName);
  });

  zE('messenger:on', 'unreadMessages', function (number) {
    const messageIndicator = document.getElementsByClassName(
      indicatorClassName
    )[0];
    const aesopIcon = document.getElementsByClassName(launcherClassName)[0];

    if (messageIndicator) {
      if (number > 0) {
        const afterTenMinutes = new Date(new Date().getTime() + 10 * 60 * 1000);
        Cookies.set(notificationsCookieName, number, {
          expires: afterTenMinutes,
        });

        messageIndicator.innerHTML = `${number}`;
        messageIndicator.style.display = 'block';
        launcher.classList.add('has-newMessage');
      }
    }

    if (aesopIcon) {
      aesopIcon.classList.add(newMessageClassName);
      setTimeout(() => {
        aesopIcon.classList.remove(newMessageClassName);
      }, 4000);
    }
  });

  zendeskContainer.append(launcher);

  const navigationSelector = document.body.querySelector(
    '[data-component="Navigation"]'
  );
  if (navigationSelector) {
    navigationSelector.after(zendeskContainer);
  }

  const checkoutLogoSelector = document.body.querySelector(
    '[data-component="NavLogo"]'
  );
  if (checkoutLogoSelector) {
    checkoutLogoSelector.after(zendeskContainer);
  }
}

// Zendesk Classic
function initChat(zE) {
  const {
    market,
    departmentList,
    departmentSelect,
    tag,
    language,
    talkSuppress,
    talkNickname,
  } = getChatDepartmentDetails();

  if (isZeDefined() && language) {
    zE('webWidget', 'setLocale', language);
  }

  if (isZeDefined()) {
    zE('webWidget', 'updateSettings', {
      ...getWidgetSettings(
        talkNickname,
        talkSuppress,
        departmentList,
        departmentSelect,
        tag,
        market[2]
      ),
    });

    zE('webWidget:on', 'chat:connected', function () {
      const aesopIcon = document.createElement('div');
      aesopIcon.classList.add(launcherClassName);
      aesopIcon.innerHTML = getLocalisedChatLabel();
      const iframeContainer = document.getElementById('launcher').parentElement;
      iframeContainer.append(aesopIcon);
      iframeContainer.classList.add(iframeContainerClass);

      // create unread message count holder
      if (document.getElementsByClassName(indicatorClassName).length < 1) {
        const unreadMessagesCount = Cookies.get(notificationsCookieName);
        const messageIndicator = document.createElement('div');
        messageIndicator.classList.add(indicatorClassName);
        if (unreadMessagesCount) {
          messageIndicator.innerHTML = unreadMessagesCount;
          messageIndicator.style.display = 'block';
        } else {
          messageIndicator.style.display = 'none';
        }

        aesopIcon.append(messageIndicator);
      }

      const dept = zE('webWidget:get', 'chat:department', departmentSelect);
      if (dept.status === 'offline') {
        zE('webWidget', 'updateSettings', {
          webWidget: {
            chat: {
              suppress: true,
            },
          },
        });
      }

      const launcherIframe = document.getElementById('launcher').contentWindow;
      launcherIframe.document.body.onclick = function () {
        window.dataLayer.push({
          event: 'custom.livechat.interaction',
          action: 'Open',
        });
      };
    });

    zE('webWidget:on', 'chat:unreadMessages', function (number) {
      if (number > 0) {
        const afterTenMinutes = new Date(new Date().getTime() + 10 * 60 * 1000);
        Cookies.set(notificationsCookieName, number, {
          expires: afterTenMinutes,
        });
      }

      const messageIndicator = document.getElementsByClassName(
        indicatorClassName
      )[0];
      const aesopIcon = document.getElementsByClassName(launcherClassName)[0];

      if (messageIndicator) {
        if (number > 0 && zE('webWidget:get', 'display') == 'launcher') {
          messageIndicator.innerHTML = number;
          messageIndicator.style.display = 'block';
        }

        if (zE('webWidget:get', 'display') == 'chat') {
          messageIndicator.style.display = 'none';
        }
      }

      if (aesopIcon) {
        aesopIcon.classList.add(newMessageClassName);
        setTimeout(() => {
          aesopIcon.classList.remove(newMessageClassName);
        }, 4000);
      }
    });

    zE('webWidget:on', 'chat:status', function (status) {
      if (status === 'offline') Cookies.remove(notificationsCookieName);
    });

    zE('webWidget:on', 'open', function () {
      const messageIndicator = document.getElementsByClassName(
        indicatorClassName
      )[0];
      messageIndicator.style.display = 'none';
      Cookies.remove(notificationsCookieName);
    });

    zE('webWidget', 'helpCenter:setSuggestions', { labels: ['promote'] });
  }
}

function openChat() {
  if (window.zE.widget === 'classic') {
    window.zE.activate();
  } else if (window.zE.widget === 'messenger') {
    window.zE('messenger', 'show');
    window.zE('messenger', 'open');
  }
}

function customEventBinding(customFn) {
  document.addEventListener(
    'click',
    function (event) {
      if (event.target.matches('[href*="custom:openZendesk"]')) {
        event.preventDefault();
        customFn?.();
        return false;
      }
    },
    false
  );
}

function loadChat() {
  if (isZeDefined()) {
    window.zE(function () {
      try {
        const widgetType = window.zE.widget;

        switch (widgetType) {
          case 'messenger':
            initMessenger(window.zE);
            console.log('Zendesk Messenger');
            break;
          case 'classic':
            initChat(window.zE);
            console.log('Zendesk Classic');
            break;
          default:
            break;
        }

        customEventBinding(openChat);
      } catch (e) {
        console.error(e);
      }
    });
  }
}

function loadChatScript({ id, useZendeskSandbox, zendeskApiKey }) {
  const firstScriptTag = document.getElementsByTagName('script')[0];
  if (document.getElementById(id)) {
    return;
  }

  const { market } = getChatDepartmentDetails();
  const key = zendeskApiKey ?? getKey(market, useZendeskSandbox);
  const chatScriptTag = document.createElement('script');
  const src = `https://static.zdassets.com/ekr/snippet.js?key=${key}`;
  chatScriptTag.id = id;
  chatScriptTag.dataset['testid'] = 'aesop-zendesk-chat';
  chatScriptTag.onload = loadChat;
  chatScriptTag.src = src;

  firstScriptTag.parentNode.insertBefore(chatScriptTag, firstScriptTag);
}

if (isChatSupported()) {
  const { useZendeskSandbox, zendeskApiKey } = parse(
    location.search.replace('?', '')
  );

  const _zendeskApiKey =
    zendeskApiKey || sessionStorage.getItem('zendeskApiKey');

  if (_zendeskApiKey) {
    sessionStorage.setItem('zendeskApiKey', _zendeskApiKey);
  }

  const _useZendeskSandbox =
    !!useZendeskSandbox || !!sessionStorage.getItem('useZendeskSandbox');

  if (_useZendeskSandbox) {
    sessionStorage.setItem('useZendeskSandbox', 'true');
  }

  loadChatScript({
    id: 'ze-snippet',
    useZendeskSandbox: _useZendeskSandbox,
    zendeskApiKey: _zendeskApiKey,
  });
}
